import React from 'react';
import { Link } from 'react-router-dom';
import { DateTimeDisplay, Breadcrumbs } from '../../components/ui';
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs';

const Manage: React.FC = () => {
    const breadcrumbs = useBreadcrumbs({ currentPageTitle: 'Manage' });

    return (
        <main>
            <div className="container mb-2">
                <section className="page">
                    <h2 className="heading__title heading__title--manage">Manage</h2>
                    <DateTimeDisplay />
                </section>

                <Breadcrumbs items={breadcrumbs} />

                <div className="row gap-1 mb-1">

                <div className='col-4-xs'>
                    <Link to="/manage/buildings" className="card card__active-alarms">
                        <div className="card__icon--buildings" />
                        <div className="card__content">
                            <h3 className="mt-0">Buildings</h3>
                            <span>Building / Customer Management</span>
                        </div>
                    </Link>
                    </div>
                    <div className='col-4-xs'>
                        <Link to="/manage/distribution-groups" className="card card__acknowledged-alarms">
                            <div className="card__icon--distribution-groups" />
                            <div className="card__content">
                                <h3 className="mt-0">Distribution Groups</h3>
                                <span>Distribution Group Management</span>
                            </div>
                        </Link>
                    </div>

                <div className='col-4-xs'>
                    <Link to="/manage/attachment-groups" className="card card__unacknowledged-alarms">
                        <div className="card__icon--attachment-groups" />
                        <div className="card__content">
                            <h3 className="mt-0">Attachment Groups</h3>
                            <span>Attachment Group Management</span>
                        </div>
                    </Link>
                </div>

                    <div className='col-4-xs'>
                        <Link to="/manage/schedules" className="card card__pending-alarms">
                            <div className="card__icon--schedule" />
                            <div className="card__content">
                                <h3 className="mt-0">Schedules</h3>
                                <span>Schedule Management</span>
                            </div>
                        </Link>
                    </div>

                    <div className='col-4-xs'>
                        <Link to="/manage/rules" className="card card__active-alarms">
                            <div className="card__icon--rules" />
                                <div className="card__content">
                                    <h3 className="mt-0">Rules</h3>
                                <span>Rules Management</span>
                            </div>
                        </Link>
                    </div>

                    <div className='col-4-xs'>
                        <div className="card card__acknowledged-alarms">
                            <div className="card__icon--pending" />
                                <div className="card__content">
                                    <h3 className="mt-0">Pending Sites</h3>
                                <span>Pending Sites Management</span>
                            </div>
                        </div>
                    </div>

                    <div className='col-4-xs'>
                        <Link to="/manage/categories" className="card card__unacknowledged-alarms">
                            <div className="card__icon--rules" />
                            <div className="card__content">
                                <h3 className="mt-0">Categories</h3>
                                <span>Category Management</span>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Manage;